import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="main-footer">
      <span>&copy; 2025. SyncTaxe. Tous droits réservés.</span>
      <span>Créé par : <Link to="https://minerve-tech.com" target="_blank">MINERVE-TECH</Link></span>
    </div>
  )
}